import { render, staticRenderFns } from "./simples_nacional_divergencias.vue?vue&type=template&id=7754e94a&scoped=true&"
import script from "./simples_nacional_divergencias.vue?vue&type=script&lang=js&"
export * from "./simples_nacional_divergencias.vue?vue&type=script&lang=js&"
import style0 from "./simples_nacional_divergencias.vue?vue&type=style&index=0&id=7754e94a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7754e94a",
  null
  
)

export default component.exports